import { BedAnatomy } from '@/features/home/BedAnatomy';
import { ClosingCta } from '@/features/home/ClosingCta';
import { DeliveryTeaser } from '@/features/home/DeliveryTeaser';
import { FaqSection } from '@/features/home/FaqSection';
import { HeroMosaic } from '@/features/home/HeroMosaic';
import { PartnersSection } from '@/features/home/PartnersSection';
import { PerksRow } from '@/features/home/PerksRow';
import { PriceList } from '@/features/home/PriceList';
import { ProcessSteps } from '@/features/home/ProcessSteps';

export const HomePage = () => (
  <>
    <HeroMosaic />
    <PerksRow />
    <BedAnatomy />
    <PriceList />
    <ProcessSteps />
    <DeliveryTeaser />
    <FaqSection />
    <PartnersSection />
    <ClosingCta />
  </>
);
